import { observer } from "mobx-react-lite";
import type { TimelineTreeNode } from "./utils/layerHierarchy";
import { LayerNodeLabel } from "./TimelineLayerNodeLabel";
import { PropertyNodeLabel } from "./TimelinePropertyNodeLabel";
import type { ModConnection } from "./TimelineLayerLabel.types";
export type { ModConnection } from "./TimelineLayerLabel.types";

type DragHandleProps = React.HTMLAttributes<HTMLButtonElement> & {
  "data-drag-enabled"?: boolean;
};

interface TimelineTreeNodeLabelProps {
  node: TimelineTreeNode;
  isPrecompExpanded?: (nodeKey: string) => boolean;
  isSelected: boolean;
  isHovered: boolean;
  isRowHovered: boolean;
  connections: ModConnection[];
  dragHandleProps?: DragHandleProps;
  dragDisabledReason?: string;
  isDropContainer?: boolean;
  isDropInside?: boolean;
  onClick: (e: React.MouseEvent) => void;
  onContextMenu: (e: React.MouseEvent) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const TimelineTreeNodeLabel = observer(
  ({
    node,
    isPrecompExpanded,
    isSelected,
    isHovered,
    isRowHovered,
    connections,
    dragHandleProps,
    dragDisabledReason,
    isDropContainer,
    isDropInside,
    onClick,
    onContextMenu,
    onMouseEnter,
    onMouseLeave,
  }: TimelineTreeNodeLabelProps) => {
    if (node.type === "layer") {
      return (
        <LayerNodeLabel
          node={node}
          isPrecompExpanded={isPrecompExpanded}
          isSelected={isSelected}
          isHovered={isHovered}
          isRowHovered={isRowHovered}
          connections={connections}
          dragHandleProps={dragHandleProps}
          dragDisabledReason={dragDisabledReason}
          isDropContainer={isDropContainer}
          isDropInside={isDropInside}
          onClick={onClick}
          onContextMenu={onContextMenu}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      );
    }

    // Property node - not clickable/selectable
    return <PropertyNodeLabel node={node} />;
  }
);

// Keep old export for backwards compatibility during migration
export { TimelineTreeNodeLabel as TimelineLayerLabel };
